import PropTypes from 'prop-types';
import {memo} from 'react';

import {
  DIFFICULTY_LEVELS,
  DIFFICULTY_LEVELS_WITH_LABELS,
} from '@/src/app/constants/course';
import {SEARCH_FILTERS} from '@/src/app/constants/search';
import TextLocal from '@/src/textLocal/containers/TextLocal';

import {CheckboxCommon, SimpleCollapse, Text} from '../../ui';
import FilterRow from '../components/FilterRow';

const DifficultyLevelFilters = ({query, onChangeHandler}) => {
  return (
    <SimpleCollapse
      defaultIsOpen
      headTitle={
        <Text
          fontSize={Text.FONT_SIZE.SIZE_16}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={'search.dificultyLevel'} />
        </Text>
      }
    >
      {DIFFICULTY_LEVELS_WITH_LABELS.map(({value}) => {
        const difficultyLevel = DIFFICULTY_LEVELS_WITH_LABELS.find(
          (level) => level.value === value
        );

        if (value === DIFFICULTY_LEVELS.ALL) return null;

        return (
          <FilterRow key={difficultyLevel.value}>
            <CheckboxCommon
              id={difficultyLevel.value}
              name={difficultyLevel.value}
              label={<TextLocal id={difficultyLevel.label} />}
              data-filter-name={SEARCH_FILTERS.FILTERS_DIFFICULTY_LEVELS}
              data-value={difficultyLevel.value}
              checked={
                !!query[SEARCH_FILTERS.FILTERS_DIFFICULTY_LEVELS] &&
                // @ts-ignore
                JSON.parse([
                  query[SEARCH_FILTERS.FILTERS_DIFFICULTY_LEVELS],
                ]).includes(difficultyLevel.value)
              }
              onChange={onChangeHandler}
              isSemibold
            />
          </FilterRow>
        );
      })}
    </SimpleCollapse>
  );
};

DifficultyLevelFilters.propTypes = {
  query: PropTypes.object.isRequired,
  onChangeHandler: PropTypes.func.isRequired,
};

export default memo(DifficultyLevelFilters);
